var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "templateItem",
    {
      attrs: {
        metadata: _vm.metadata,
        isSelected: _vm.isSelected,
        parentId: _vm.parentId,
        classes: _vm.classes,
        styles: _vm.cssRules,
        controlsStyle: "right: -33px; top: -26px;",
        locked: _vm.locked,
        isParent: _vm.isParent
      },
      on: {
        "delete-item": function($event) {
          return _vm.$emit("delete-block", $event)
        },
        "select-item": function($event) {
          return _vm.$emit("select-block", $event)
        },
        "move-item": function($event) {
          return _vm.$emit("move-block", $event)
        },
        "lock-item": function($event) {
          return _vm.$emit("lock-block", $event)
        },
        "unselect-all": function($event) {
          _vm.selectedRow = null
        }
      }
    },
    [
      _vm.showSettings
        ? [
            _c("TemplateBlockSettings", {
              attrs: {
                width: _vm.width,
                color: _vm.metadata.style.color,
                border: _vm.metadata.style.border,
                borderColor: _vm.metadata.style.borderColor,
                radius: _vm.metadata.style.radius
              },
              on: {
                "change-color": function($event) {
                  return _vm.$emit("change-color", $event)
                },
                "change-border-color": function($event) {
                  return _vm.$emit("change-border-color", $event)
                },
                "change-width": function($event) {
                  return _vm.$emit("change-width", $event)
                },
                "set-border": function($event) {
                  return _vm.$emit("set-border", $event)
                },
                "change-radius": function($event) {
                  return _vm.$emit("change-radius", $event)
                }
              }
            })
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.rowsReady
        ? _c(
            "div",
            _vm._l(_vm.sortedRows, function(row) {
              return _c("templateRow", {
                key: row._key,
                attrs: {
                  id: row.Id,
                  currentTemplateId: _vm.currentTemplateId,
                  templateId: row.TemplateId,
                  parentId: row.ParentId,
                  isSelected: _vm.selectedRow === row,
                  locked: row.IsLocked,
                  lockStateChanged: row.LockStateChanged,
                  rowTypeId: row.RowTypeId,
                  blockId: row.BlockId,
                  metadata: row.Metadata,
                  columns: row.Columns,
                  rowTypes: _vm.rowTypes,
                  parentColor: _vm.metadata.style.color
                },
                on: {
                  "select-row": function($event) {
                    _vm.selectedRow = row
                  },
                  "delete-row": function($event) {
                    return _vm.deleteRow($event)
                  },
                  "change-color": function($event) {
                    row.Metadata.style.color = $event
                  },
                  "move-row": function($event) {
                    return _vm.moveRow($event.old, $event.new)
                  },
                  "lock-row": function($event) {
                    return _vm.toggleRowLock(row, $event)
                  },
                  "item-added": function($event) {
                    return _vm.$emit("item-added")
                  }
                }
              })
            }),
            1
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.lockedByParent
        ? _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-auto mx-auto" }, [
              _c(
                "a",
                {
                  staticClass: "mdb-icon-btn new",
                  attrs: {
                    href: "javascript:void(0)",
                    "data-toggle": "tooltip",
                    title: _vm.tooltips.insertRow
                  },
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                      _vm.pickingRow = true
                    }
                  }
                },
                [_c("i", { staticClass: "fa fa-plus-circle fa-2x" })]
              ),
              _vm._v(" "),
              _vm.pickingRow
                ? _c(
                    "div",
                    {
                      staticClass: "item-picker text-center",
                      on: {
                        mouseleave: function($event) {
                          _vm.pickingRow = false
                        }
                      }
                    },
                    [
                      _c("div", { staticClass: "row" }, [
                        _c(
                          "div",
                          { staticClass: "col-12 item-picker-header" },
                          [
                            _c("span", [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(
                                    _vm.resource(
                                      "TemplateBlock_SchemePicker_Title"
                                    )
                                  ) +
                                  "\n                        "
                              )
                            ])
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "row" }, [
                        _vm.rowsReady
                          ? _c(
                              "div",
                              { staticClass: "col-12 item-picker-content" },
                              [
                                _c(
                                  "table",
                                  { attrs: { width: "100%" } },
                                  _vm._l(_vm.rowTypes, function(row) {
                                    return _c(
                                      "tr",
                                      {
                                        key: row.id,
                                        attrs: { id: row.Id },
                                        on: {
                                          click: function($event) {
                                            $event.stopPropagation()
                                            return _vm.addRow(row.Id)
                                          }
                                        }
                                      },
                                      _vm._l(row.Value.columns, function(
                                        column
                                      ) {
                                        return _c(
                                          "td",
                                          {
                                            key: column.id,
                                            attrs: {
                                              colspan: _vm.getColumnSize(column)
                                            }
                                          },
                                          [
                                            _c("div", {
                                              staticClass: "item-picker-column"
                                            })
                                          ]
                                        )
                                      }),
                                      0
                                    )
                                  }),
                                  0
                                )
                              ]
                            )
                          : _vm._e()
                      ])
                    ]
                  )
                : _vm._e()
            ])
          ])
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }